import React, { Fragment } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { FAQItem } from 'cards/seo/types';

type QuestionSchema = {
  '@type': 'Question';
  name: string;
  acceptedAnswer: {
    '@type': 'Answer';
    text: string;
  };
};

type SEOSchema = {
  '@context': string;
  '@type': string;
  mainEntity: QuestionSchema[];
};

const getSEOSchema = (content: FAQItem[]): SEOSchema => ({
  '@context': 'https://schema.org/',
  '@type': 'FAQPage',
  mainEntity: content.map(entity => ({
    '@type': 'Question',
    name: entity.subheading,
    acceptedAnswer: {
      '@type': 'Answer',
      text: renderToStaticMarkup(<Fragment>{entity.body}</Fragment>),
    },
  })),
});

export default getSEOSchema;
